import { useEffect } from 'react';
import { useAttribution } from './attribution';
import { useLeafletContext } from './context';
import { useEventHandlers } from './events';
import { withPane } from './pane';
export function useLayerLifecycle(element, context) {
  useEffect(function addLayer() {
    var _context$layerContain2;
    var container = (_context$layerContain2 = context.layerContainer) !== null && _context$layerContain2 !== void 0 ? _context$layerContain2 : context.map;
    container.addLayer(element.instance);
    return function removeLayer() {
      var _context$layerContain;
      (_context$layerContain = context.layerContainer) == null ? void 0 : _context$layerContain.removeLayer(element.instance);
      context.map.removeLayer(element.instance);
    };
  }, [context, element]);
}
export function createLayerHook(useElement) {
  return function useLayer(props) {
    var context = useLeafletContext();
    var elementRef = useElement(withPane(props, context), context);
    useAttribution(context.map, props.attribution);
    useEventHandlers(elementRef.current, props.eventHandlers);
    useLayerLifecycle(elementRef.current, context);
    return elementRef;
  };
}